// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".marker {\n  background-color: rgba(255, 255, 255, 0);\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n/* div containing the marker parent */\n.clearMarkerContainer {\n  background-color: rgba(57, 57, 216, 0);\n  display: flex;\n  justify-content: center;\n}\n", ""]);
// Exports
module.exports = exports;
